<template>
    <div>
        <header
            class="fixed top-0 z-40 w-full text-center bg-white shadow-lg l-0 md:w-screen"
        >
            <sparator v-show="showSparator"></sparator>

            <div
                class="relative grid grid-cols-3 gap-10 overflow-hidden mx-150 md:mx-50 py-15"
            >
                <div
                    class="flex items-center -mx-2 transition-all duration-1000 ease-in-out md:fixed md:z-20 md:bottom-0 md:left-0 md:justify-center md:w-full md:-mx-0 md:pb-50"
                    :class="{
                        'md:visible md:opacity-100 md:translate-x-0': menuActive,
                        'md:invisible md:opacity-0 ': !menuActive
                    }"
                >
                    <a
                        href="https://twitter.com/tanambenih?lang=en"
                        rel="noopener noreferrer"
                        target="_blank"
                        class="mx-15"
                    >
                        <icon
                            name="twitter"
                            class="stroke-0 w-35 h-35 fill-black"
                        />
                    </a>
                    <a
                        href="https://www.facebook.com/tanambenih/"
                        rel="noopener noreferrer"
                        target="_blank"
                        class="mx-15"
                    >
                        <icon
                            name="facebook"
                            class="stroke-0 w-35 h-35 fill-black"
                        />
                    </a>
                    <a
                        href="https://www.instagram.com/tanam_benih/?hl=en"
                        rel="noopener noreferrer"
                        target="_blank"
                        class="mx-15"
                    >
                        <icon name="instagram" class="w-35 h-35 " />
                    </a>
                    <a
                        href="https://www.youtube.com/channel/UCLHYVn1DxrzvV3gl2bME4wQ"
                        rel="noopener noreferrer"
                        target="_blank"
                        class="mx-15"
                    >
                        <icon name="youtube" class="stroke-1 w-35 h-35 " />
                    </a>
                </div>
                <div
                    :class="{
                        ' -translate-x-300 ': menuActive,
                        ' translate-x-0 opacity-100': !menuActive
                    }"
                    class="flex items-center justify-center col-start-2 transition-all duration-1000 ease-in-out transform md:translate-x-0"
                >
                    <a href="">
                        <img
                            src="storage/pages/all/logo.png"
                            alt="logo-tanam-benih"
                            class="transition-all duration-1000 ease-in-out md:h-80"
                            :class="{
                                'h-80': menuActive,
                                ' h-120': !menuActive
                            }"
                        />
                    </a>
                </div>
                <div
                    class="relative flex items-center justify-end col-start-3 md:z-20"
                >
                    <svg
                        class="hamburger-icon w-80"
                        @click="menuActive = !menuActive"
                        viewBox="0 0 100 100"
                        width="80"
                        :class="{ '-active': menuActive }"
                    >
                        <path
                            class="line top"
                            d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20"
                        />
                        <path class="line middle" d="m 70,50 h -40" />
                        <path
                            class="line bottom"
                            d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"
                        />
                    </svg>
                </div>
                <div
                    class="absolute right-0 inline-flex transition-all duration-1000 ease-in-out transform -translate-y-1/2 top-1/2 mr-50 md:fixed md:w-full md:h-full md:mr-0 md:bg-white md:flex-col md:items-center md:justify-center md:z-10"
                    :class="{
                        'visible opacity-100 translate-x-0': menuActive,
                        'invisible opacity-0 ': !menuActive
                    }"
                >
                    <!-- <a
                        class="mr-20 font-medium  text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                        @click="toggleShowSparator"
                        href="/"
                        ><div class="relative ">
                            <div class="py-20 ">Home</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'home.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div></a
                    >
                    <a
                        class="mr-20 font-medium  text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                        @click="toggleShowSparator"
                        href="/how-to-contribute"
                        ><div class="relative ">
                            <div class="py-20 ">How to Contribute</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'contribute.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div></a
                    > -->
                    <!-- <router-link
                        :to="{ name: 'home' }"
                        class="mr-20 font-medium  text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                    >
                        <div class="relative ">
                            <div class="py-20 ">Home</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'home.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div>
                    </router-link> -->
                    <!-- <router-link
                        :to="{ name: 'contribute' }"
                        class="mr-20 font-medium  text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                    >
                        <div class="relative ">
                            <div class="py-20 ">How to Contribute</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'contribute.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div>
                    </router-link> -->
                    <inertia-link
                        @click="toggleShowSparator"
                        :href="route('home.index')"
                        class="mr-20 font-medium  text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                    >
                        <div class="relative ">
                            <div class="py-20 ">Home</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'home.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div>
                    </inertia-link>
                    <inertia-link
                        @click="toggleShowSparator"
                        :href="route('whoweare.index')"
                        class="mr-20 font-medium text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                    >
                        <div class="relative">
                            <div class="py-20">Who We Are</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'whoweare.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div>
                    </inertia-link>
                    <inertia-link
                        @click="toggleShowSparator"
                        :href="route('contribute.index')"
                        class="mr-20 font-medium text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                    >
                        <div class="relative">
                            <div class="py-20">How to Contribute</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'contribute.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div>
                    </inertia-link>
                    <inertia-link
                        @click="toggleShowSparator"
                        :href="route('donate.index')"
                        class="mr-20 font-medium text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                    >
                        <div class="relative">
                            <div class="py-20">Donate</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'donate.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div>
                    </inertia-link>
                    <a
                        href="https://theparentingacademy.com/"
                        target="_blank"
                        class="mr-20 font-medium text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                        id="link"
                    >
                        <div class="relative">
                            <div class="py-20">The Parenting Academy</div>
                            <div
                                class="absolute bottom-0 left-0 hidden w-full leading-none text-center text-green-500 text-60"
                            >
                                .
                            </div>
                        </div>
                    </a>
                    <inertia-link
                        @click="toggleShowSparator"
                        :href="route('contactus.index')"
                        class="mr-20 font-medium text-18 focus:text-green-500 md:text-35 md:mr-0 md:mb-20"
                    >
                        <div class="relative">
                            <div class="py-20">Contact us</div>
                            <div
                                class="absolute bottom-0 left-0 w-full leading-none text-center text-green-500 text-60 "
                                :class="
                                    route().current() === 'contactus.index'
                                        ? ''
                                        : 'hidden'
                                "
                            >
                                .
                            </div>
                        </div>
                    </inertia-link>
                </div>
            </div>
        </header>

        <div
            class="fixed top-0 left-0 z-40 flex items-center justify-center w-full h-full transform bg-gray-400"
            loading
        >
            <div
                loading-text
                class="text-5xl font-bold tracking-widest text-black"
            >
                TANAM BENIH<span class="ml-4 text-green-500">.</span>
            </div>
        </div>

        <div scroll-region class="pt-60 md:pt-100">
            <transition
                name="fade"
                @appear="enter"
                @leave="leave"
                @enter="enter"
                appear
            >
                <div v-if="show" :class="show ? 't' : 'f'">
                    <slot />
                </div>
            </transition>
        </div>

        <div class="bg-footer">
            <div class="mx-150 md:mx-50 pt-170 pb-100">
                <div class="flex items-end md:flex-col md:items-start">
                    <div class="mr-300 md:mr-0 md:mb-50">
                        <img
                            src="storage/pages/all/logo-white.png"
                            alt="logo-tanam-benih"
                            class="md:w-300"
                        />
                        <div class="flex items-center -mx-25 mt-150 md:mt-50">
                            <a
                                href="https://twitter.com/tanambenih?lang=en"
                                target="_blank"
                                class="mx-25"
                            >
                                <icon
                                    name="twitter"
                                    class="stroke-0 w-30 h-30 fill-white"
                                />
                            </a>
                            <a
                                href="https://www.facebook.com/tanambenih/"
                                target="_blank"
                                class="mx-25"
                            >
                                <icon
                                    name="facebook"
                                    class="stroke-0 w-30 h-30 fill-white"
                                />
                            </a>
                            <a
                                href="https://www.instagram.com/tanam_benih/?hl=en"
                                target="_blank"
                                class="mx-25"
                            >
                                <icon
                                    name="instagram"
                                    class="text-white w-30 h-30"
                                />
                            </a>
                            <a
                                href="https://www.youtube.com/channel/UCLHYVn1DxrzvV3gl2bME4wQ"
                                target="_blank"
                                class="mx-25"
                            >
                                <icon
                                    name="youtube-white"
                                    class="stroke-0 w-30 h-30 "
                                />
                            </a>
                        </div>
                    </div>
                    <div class="flex flex-col flex-1 md:mb-50">
                        <inertia-link
                            class="mb-40 text-white whitespace-no-wrap text-30 md:mb-20"
                            :href="route('home.index')"
                            >Homepage</inertia-link
                        >
                        <inertia-link
                            class="mb-40 text-white whitespace-no-wrap text-30 md:mb-20"
                            :href="route('whoweare.index')"
                            >Who We Are</inertia-link
                        >
                        <inertia-link
                            class="mb-40 text-white whitespace-no-wrap text-30 md:mb-20"
                            :href="route('contribute.index')"
                            >How to Contribute</inertia-link
                        >
                        <inertia-link
                            class="mb-40 text-white whitespace-no-wrap text-30 md:mb-20"
                            :href="route('donate.index')"
                            >Donate</inertia-link
                        >
                        <inertia-link
                            class="mb-40 text-white whitespace-no-wrap text-30 md:mb-20"
                            :href="route('contactus.index')"
                            >Contact Us</inertia-link
                        >
                        <inertia-link
                            class="text-white whitespace-no-wrap text-30"
                            :href="route('terms.index')"
                            >Terms and Conditions</inertia-link
                        >
                    </div>
                    <div class="ml-300 md:ml-0">
                        <div class="text-gray-400 text-20">
                            © 2020-2023 Tanam Benih Foundation. All rights
                            reserved. The material on this site may not be
                            reproduced, distributed, transmitted, cached or
                            otherwise used, except with prior written permission
                            of Tanam Benih Foundation.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from "animejs";
import Icon from "@/Shared/Icon";
import Sparator from "../../components/Sparator.vue";

export default {
    components: {
        Icon,
        Sparator
    },
    data() {
        return {
            showSparator: false,
            show: true,
            menuActive: false
        };
    },
    methods: {
        toggleShowSparator() {
            this.showSparator = true;
            console.log("oke");
            // setTimeout(() => (this.showSparator = false), 6000);
        },

        enter(el, done) {
            let dl = anime.timeline({
                duration: 5000
            });
            dl.add({
                targets: "[loading-sparator]"
            });
            let tl = anime.timeline({
                duration: 500,
                easing: "cubicBezier(0.4, 0, 0.2, 1)"
            });
            tl.add({
                targets: "[loading-text]",
                opacity: [1, 0]
            })
                .add(
                    {
                        targets: "[loading]",
                        translateY: ["0", "-100%"]
                    },
                    "-=300"
                )
                .add({
                    targets: "[anime-image]",
                    // opacity: [0, 1],
                    scale: [1.1, 1]
                })
                .add({
                    targets: "[anime-title]",
                    opacity: [0, 1],
                    translateY: ["50%", "0"]
                });
            tl.finished.then(() => {
                done();
            });
        },
        leave(el, done) {
            let tl = anime.timeline({
                duration: 500,
                easing: "cubicBezier(0.4, 0, 0.2, 1)"
            });
            tl.add({
                targets: "[loading]",
                translateY: ["100%", "0"]
            }).add(
                {
                    targets: "[loading-text]",
                    opacity: [0, 1]
                },
                "-=750"
            );
            tl.finished.then(() => {
                setTimeout(() => {
                    this.show = true;
                    done();
                }, 100);
            });
        }
    },
    mounted() {
        history.pushState = (f =>
            function pushState() {
                var ret = f.apply(this, arguments);
                window.dispatchEvent(new Event("pushstate"));
                window.dispatchEvent(new Event("locationchange"));
                return ret;
            })(history.pushState);
        history.replaceState = (f =>
            function replaceState() {
                var ret = f.apply(this, arguments);
                window.dispatchEvent(new Event("replacestate"));
                window.dispatchEvent(new Event("locationchange"));
                return ret;
            })(history.replaceState);
        window.addEventListener("popstate", () => {
            window.dispatchEvent(new Event("locationchange"));
        });
        window.addEventListener("pushstate", () => {
            this.show = false;
            this.showSparator = false;
            this.menuActive = false;
            console.log("pushstate changed!");
        });
    }
};
</script>
